import { useEffect, useState } from "react";
import { Gem, Sun, ScrollText } from "lucide-react";

const THEMES = [
  { id: "luxury", label: "Luxury", icon: Gem },
  { id: "light", label: "Light", icon: Sun },
  { id: "editorial", label: "Editorial", icon: ScrollText },
];

export const useTheme = () => {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("adk-theme") || "luxury"
  );
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("adk-theme", theme);
  }, [theme]);
  return { theme, setTheme };
};

export const ThemeSwitcher = ({ theme, setTheme }) => {
  return (
    <div
      data-testid="theme-switcher"
      className="flex items-center gap-1 p-1 rounded-full"
      style={{ background: "var(--bg-surface)", border: "1px solid var(--border-color)" }}
    >
      {THEMES.map((t) => {
        const Icon = t.icon;
        const active = theme === t.id;
        return (
          <button
            key={t.id}
            data-testid={`theme-option-${t.id}`}
            onClick={() => setTheme(t.id)}
            aria-label={`${t.label} theme`}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all"
            style={{
              background: active ? "var(--accent-primary)" : "transparent",
              color: active ? "var(--accent-contrast)" : "var(--text-secondary)",
            }}
          >
            <Icon size={14} strokeWidth={1.5} />
            <span className="hidden sm:inline">{t.label}</span>
          </button>
        );
      })}
    </div>
  );
};
